export default __webpack_public_path__ + "static/media/BFT-logo.f7e35d39.png";